import { ErrorNotification } from '@ardoq/status-ui';
import styled from 'styled-components';
import { t, type I18nLocale } from '@ardoq/i18n';

type GremlinSearchErrorProps = {
  syntaxError: string | null;
  i18nLocale: I18nLocale;
};

const SyntaxError = styled(ErrorNotification)`
  font-family: monospace;
  white-space: pre-wrap;
`;

const GremlinSearchError = ({
  syntaxError,
  i18nLocale,
}: GremlinSearchErrorProps) => {
  if (syntaxError) return <SyntaxError>{syntaxError}</SyntaxError>;
  return (
    <ErrorNotification>
      <p>
        {t(
          i18nLocale,
          'search:gremlinSearchError.message',
          'An error occurred while searching. We have been notified and are sorry about the inconvenience.'
        )}
      </p>
      {t(
        i18nLocale,
        'search:gremlinSearchError.contactSupport',
        'If the error persists, please contact support.'
      )}
    </ErrorNotification>
  );
};

export { GremlinSearchError };
